import { TemplateType } from '@/types/boot';
import { TemplateConfigurations, type TemplateFeatures } from '@/constants/templateConfig';
import { EmbeddedPreferredPaymentView } from '@/templateViews/EmbeddedPreferredPaymentView';
import { PreferredPaymentTemplate } from './PreferredPaymentTemplate';
import type { TemplateView } from './CheckoutTemplate';

/**
 * PREFERRED single-CTA flow (FTD + last method) inside the Supercell
 * embedded shell.
 *
 * Eligibility and the default method are inherited from
 * {@link PreferredPaymentTemplate}. The only deltas are presentational
 * ({@link EmbeddedPreferredPaymentView} swaps the publisher hero for
 * {@link TotalSummaryCard}) and the degrade target: every soft-fail
 * (desktop, missing last method, wallet unavailable, "Use other payment
 * method") lands on {@link TemplateType.EMBEDDED_VIEW} rather than DEFAULT.
 * EMBEDDED_VIEW itself still degrades to DEFAULT on desktop, so a desktop
 * session that asked for this template ends on the standard checkout.
 */
export class EmbeddedPreferredPaymentTemplate extends PreferredPaymentTemplate {
  override readonly type: TemplateType = TemplateType.EMBEDDED_PREFERRED_PAYMENT_METHOD;
  override readonly View: TemplateView = EmbeddedPreferredPaymentView;
  override readonly features: TemplateFeatures = TemplateConfigurations[TemplateType.EMBEDDED_PREFERRED_PAYMENT_METHOD];
  override readonly fallbackTemplateType: TemplateType = TemplateType.EMBEDDED_VIEW;
}
